<div>
	<table mat-table [dataSource]="dataSource" [trackBy]="trackByRow" class="table-responsive" matSort style="width: 100%" [multiTemplateDataRows]="!!expandableDetailTemplate">
		<ng-container matColumnDef="expand" *ngIf="expandableDetailTemplate">
			<th mat-header-cell *matHeaderCellDef [ngStyle]="{ width: '1%' }"></th>
			<td mat-cell *matCellDef="let rowData">
				@let open = rowExpanded ? rowExpanded(rowData) : expandedRow === rowData;
				@if (open !== null) {
					<button mat-icon-button disableRipple="true" type="button" aria-label="Toggle row details" (click)="$event.stopPropagation(); toggleRowExpand(rowData)">
						<mat-icon mat-list-icon svgIcon="acies_chevrondown" class="generictable-detail-toggle" [class.generictable-detail-open]="open"></mat-icon>
					</button>
				}
			</td>
		</ng-container>

		@if (hasSelectColumn) {
			<ng-container matColumnDef="select">
				<th mat-header-cell *matHeaderCellDef [ngStyle]="{ width: '5%' }">
					<mat-icon mat-list-icon [svgIcon]="selectManager.isAllSelected ? 'acies_check' : 'acies_uncheck'" (click)="selectManager.selectOrClearAll()"></mat-icon>
				</th>
				<td mat-cell *matCellDef="let row">
					<mat-icon mat-list-icon [svgIcon]="selectManager.isSelected(row.id) ? 'acies_check' : 'acies_uncheck'" (click)="selectManager.select(row)"></mat-icon>
				</td>
			</ng-container>
		}

		@for (column of tableColumns; track column) {
			<ng-container [matColumnDef]="column.dataKey">
				<th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="'tableheader-' + column.dataKey" [ngStyle]="{ width: (column.width ?? 97 / colCount) + '%' }">
					{{ column.name | translate }}
				</th>
				<td mat-cell *matCellDef="let rowData">
					@if (column.isStatusIcon) {
						<mat-icon svgIcon="{{ parsedValue(rowData, column) }}" [ngClass]="parsedValue(rowData, column) === 'acies_true' ? 'greenColor' : parsedValue(rowData, column) === 'acies_false' ? 'redColor' : 'pendingScale'"></mat-icon>
					}
					@if (column.isImg) {
						<img src="{{ getColValueFromRow(rowData, column) }}" />
					}
					@if (column.isLink && column.linkIcon) {
						<a class="generictable-icon-link" [href]="getColValueFromRow(rowData, column)" target="_blank" [attr.rel]="column.linkOpener ? 'opener' : null" [title]="column.linkTitle | translate">
							<mat-icon [svgIcon]="column.linkIcon"></mat-icon>
						</a>
					}
					@if (!column.isImg && !column.isStatusIcon && !(column.isLink && column.linkIcon)) {
						<span [innerHTML]="column.pipe ? (parsedValue(rowData, column) | dynamicPipe: column.pipe : column.pipeArgs) : parsedValue(rowData, column)"></span>
					}
				</td>
			</ng-container>
		}

		@if (rowActions) {
			<ng-container matColumnDef="rowMenu">
				<th mat-header-cell *matHeaderCellDef [ngStyle]="{ width: '1%', 'text-align': 'end' }">
					@if (selectActionManager === undefined || !selectManager.isAnySelected()) {
						<span>
							{{ 'general.actions' | translate }}
						</span>
					}
					@if (selectActionManager !== undefined && selectManager.isAnySelected()) {
						<button disableRipple="true" mat-icon-button [matMenuTriggerFor]="menuMulti" aria-label="Multi select menu" (click)="selectActionManager.prepareVisibleActions()">
							<mat-icon mat-list-icon class="account-select-icon" svgIcon="acies_overflow_menu" style="padding-top: 5px; overflow: visible"></mat-icon>
						</button>
						<mat-menu #menuMulti="matMenu">
							@for (action of selectActionManager.currentVisibleActions; track action) {
								<app-action-menu-element [action]="action" (actionClick)="emitSelectAction(action.definition)"></app-action-menu-element>
							}
						</mat-menu>
					}
				</th>
				<td mat-cell *matCellDef="let rowData" style="text-align: end">
					<button disableRipple="true" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Edit user settings" (click)="itemActionManager.prepareVisibleActions(rowData)">
						<mat-icon mat-list-icon class="account-select-icon" svgIcon="acies_overflow_menu" style="padding-top: 5px; overflow: visible"></mat-icon>
					</button>
					<mat-menu #menu="matMenu">
						@for (action of itemActionManager.currentVisibleActions; track action) {
							<app-action-menu-element [action]="action" (actionClick)="emitToParent(action.definition, rowData)"></app-action-menu-element>
						}
					</mat-menu>
				</td>
			</ng-container>
		}

		<ng-container matColumnDef="expandedDetail">
			<td mat-cell *matCellDef="let rowData" [attr.colspan]="columnsToDisplay.length" class="generictable-detail-cell">
				<ng-container *ngTemplateOutlet="expandableDetailTemplate; context: { $implicit: rowData }"></ng-container>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
		<tr mat-row *matRowDef="let rowData; columns: columnsToDisplay" [ngClass]="rowClass ? rowClass(rowData) : ''"></tr>
		<tr mat-row *matRowDef="let rowData; columns: ['expandedDetail']; when: isExpandedRow" class="generictable-detail-row"></tr>
	</table>
	@if (showPaginator) {
		<mat-paginator [pageSizeOptions]="pageSizes" [pageSize]="initialPageSize" [showFirstLastButtons]="true" [length]="totalRowCount"></mat-paginator>
	}
</div>
<ng-template #noDataDiv>Loading...</ng-template>
